import React from "react";
import { Modal } from "antd";
import "./../addNewLinkRegular/AddNewLinkRegular.css";
import BlockPicker from "./BlockPicker";
import "./ModalLinkCreation.css";
import FormLinkCreation from "./FormLinkCreation";

const ModalLinkCreation = ({
  displayBlockPicker,
  setDisplayBlockPicker,
  modalOpen,
  setModalOpen,
  closeModal,
  isEdittingLink,
  linkType,
  currentLinkType,
  setCurrentLinkType,
  setLinkType,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
}) => {
  const cancelModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setEdittingLink(false);
    }, 200);
  };

  return (
    <div>
      <Modal
        className="add-new-link-regular"
        // title="Ajouter un lien"
        width={800}
        visible={modalOpen}
        footer={null}
        // onOk={this.handleOk}
        onCancel={() => {
          cancelModal();
        }}
      >
        {displayBlockPicker && !isEdittingLink ? (
          <>
            <BlockPicker
              setDisplayBlockPicker={setDisplayBlockPicker}
              setCurrentLinkType={setCurrentLinkType}
            />
          </>
        ) : (
          <>
            <FormLinkCreation
              setModalOpen={setModalOpen}
              closeModal={closeModal}
              isEdittingLink={isEdittingLink}
              currentLinkType={currentLinkType}
              setCurrentLinkType={setCurrentLinkType}
              setEdittingLink={setEdittingLink}
              linkEditDetails={linkEditDetails}
              currentLinks={currentLinks}
              setRefresh={setRefresh}
              refresh={refresh}
              setDisplayBlockPicker={setDisplayBlockPicker}
            />
          </>
        )}
      </Modal>
    </div>
  );
};

export default ModalLinkCreation;
